<template>
  <div class="login">
    <img class= "imgthermo" src="http://www.suypro.es/img/logo-header-default.png" >
    <h3>Entrar</h3>
    <input type="text" v-model="email" placeholder="Email"><br>
    <input type="password" v-model="password" placeholder="Password"><br>
    <button @click="login">Conectar</button>
    <p>¿No tienes  cuenta de usuario? Puedes  <router-link to="/sign-up">crearte una</router-link></p>
  </div>
</template>

<script>
  import firebase from 'firebase';
  
  
  export default {
    name: 'login',
    data() {
      return {
        email: '',
        password: '',
        ThermoDevice:''
      }
    },
    methods: {
      login: function() {
        firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
          (user) => {
              let url = "usuarios/" + user.user.uid
            firebase.database().ref(url).once('value',(snapshot) => {
                
                if (snapshot.val()){
                    this.ThermoDevice = snapshot.val().device1
                    this.$store.commit("SetThermo", this.ThermoDevice)
                    console.log('Dispositivo: ' + this.ThermoDevice)
                    this.$router.push({path: '/thermo'})
                }
                else{
                    this.$router.push({path: '/asig-device'})
                }
            })
            
          },
          (err) => {
            alert('Oops. ' + err.message)
          }
        );
      }
    },
    mounted(){
         let user = firebase.auth().currentUser;
        if (user != null){
            let url = "usuarios/" + user.uid
            firebase.database().ref(url).once('value',(snapshot) => {
                this.ThermoDevice = snapshot.val().device1
                this.$store.commit("SetThermo", this.ThermoDevice)
                console.log('Dispositivo: ' + this.ThermoDevice)
                this.$router.push({path: '/thermo'})
            })
        }
    },
  }
</script>

<style scoped>  /* "scoped" attribute limit the CSS to this component only */
  .login {
    margin-top: 40px;
  }
  input {
    margin: 10px 0;
    width: 60%;
    padding: 15px;
  }
  button {
    margin-top: 20px;
    width: 40%;
    cursor: pointer;
  }
  p {
    margin-top: 40px;
    font-size: 13px;
  }
  p a {
    text-decoration: underline;
    cursor: pointer;
  }
</style>